/*
 * @Desc: 
 * @Author: lc
 * @Date: 2023-05-25 14:30:25
 * @LastEditors: lc
 * @LastEditTime: 2023-05-25 17:45:19
 */
/**
  * 交换积分
  */
import axios from '../http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来

const api = '/c-api/';

const tongbucompany = {
    // 列表
    list (params) {
        return axios.get(api + 'tongbucompany/list', { params: params });
    },
    // 添加
    create (params) {
        return axios.post(api + 'tongbucompany/create', qs.stringify(params))
    },
    // 修改
    edit (params) {
        return axios.post(api + 'tongbucompany/edit', qs.stringify(params))
    },
    // 单个查看
    detail (params) {
        return axios.get(api + 'tongbucompany/detail', { params: params })
    },
    // 删除
    remove (params) {
        return axios.post(api + 'tongbucompany/remove', qs.stringify(params))
    },
    goodlist (params) {
        return axios.get(api + 'tongbucompany/goodlist', { params: params })
    },
}


// 导出接口
export default tongbucompany
